/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Fake_Pay_TitleInputs */

const id_billing_fake_pay_title = /** @type {(inputs: Billing_Fake_Pay_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gateway uji coba`)
};

const en_billing_fake_pay_title = /** @type {(inputs: Billing_Fake_Pay_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test gateway`)
};

/**
* | output |
* | --- |
* | "Test gateway" |
*
* @param {Billing_Fake_Pay_TitleInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_fake_pay_title = /** @type {((inputs?: Billing_Fake_Pay_TitleInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Fake_Pay_TitleInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_fake_pay_title(inputs)
	return id_billing_fake_pay_title(inputs)
});